import { noCase } from 'no-case'
import type { z } from 'zod'

import UserError from './UserError'

export default function transformZodError(err: z.ZodError): UserError {
  const errorStrings: string[] = []
  const { formErrors, fieldErrors } = err.flatten()

  formErrors.forEach(item => {
    errorStrings.push(`invalid request: ${item}`)
  })
  Object.keys(fieldErrors).forEach(fieldName => {
    errorStrings.push(`${noCase(fieldName)}: ${fieldErrors[fieldName]}`)
  })

  const errorLines = errorStrings.map(item => `  - ${item}`).join('\n')
  return errorStrings.length === 1
    ? new UserError({
        type: 'validation',
        externalMessage: `There was an issue with your submission: ${errorStrings[0]}`,
      })
    : new UserError({
        type: 'validation',
        externalMessage: `There are some issues with your request:\n${errorLines}`,
      })
}
